// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WQrW","col":"styles_col__2FWka"};